export default __webpack_public_path__ + "static/media/C2C.8c15bb49.png";